import React from "react";
import {ISlsOrd} from "../../../kova/slsordClient";
import {IViewMap} from "../../../data/IViewpoint";
import {BigScreenCommunityMap} from "../communitymap/BigScreenCommunityMap";

export const SiteSpecific2DMap: React.FC<{
    lotId?:string,

    selectedViewItem: IViewMap
}> = (props) => {
    const {lotId} = props;
    return <BigScreenCommunityMap lotId={lotId} viewBox={props.selectedViewItem.viewBox}/>
}